/** Endpoint #29 — export of the current Posts view (§5.1, ASSUMPTION A-9). */
import { z } from 'zod';
import { POSTS_COLUMNS } from '../columns.js';
import { EXPORT_FORMATS } from '../enums.js';
import { PostsQuerySchema } from './posts.js';
const POSTS_COLUMN_ID_VALUES = POSTS_COLUMNS.map((c) => c.id);
const ColumnsParamSchema = z
    .string()
    .transform((raw) => raw
    .split(',')
    .map((part) => part.trim())
    .filter((part) => part.length > 0))
    .pipe(z.array(z.enum(POSTS_COLUMN_ID_VALUES)).min(1));
/**
 * #29 `GET /api/views/:t/:id/posts/export`
 *
 * Same filter/sort params as #25 (offset/limit are ignored — the whole result set streams up to
 * `EXPORT_ROW_CAP`), plus the output format and, for CSV, the visible column list.
 */
export const ExportQuerySchema = PostsQuerySchema.extend({
    format: z.enum(EXPORT_FORMATS).default('csv'),
    /** CSV only: visible columns in display order; defaults to the default-visible set. */
    columns: ColumnsParamSchema.optional(),
});
//# sourceMappingURL=exports.js.map